import { api } from '../configs/axiosConfigs';

export const getSavedSearchCriteria = async () => {
  return await api.get('/property_search_criteria.json');
};
